import React, { useState, useEffect } from "react";
import "../styles/App.css";
import { SERVER_URL } from "../config";
import toast from "react-hot-toast";

interface User {
  id: string;
  email: string;
  jobTitle?: string;
  user: {
    role: string;
    email: string;
    createdAt: string;
  };
  firstName: string;
  lastName: string;
  phone?: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
}

interface EditProfileProps {
  user: User;
}

const EditProfile: React.FC<EditProfileProps> = ({ user }) => {
  const [formData, setFormData] = useState({
    email: user.email,
    password: "",
    firstName: user.firstName,
    lastName: user.lastName,
    phone: user.phone || "",
    jobTitle: user.jobTitle || "",
  });

  const [message, setMessage] = useState("");

  useEffect(() => {
    setFormData({
      email: user.email,
      password: "",
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone || "",
      jobTitle: user.jobTitle || "",
    });
  }, [user]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      // Update user info (email + password)
      await fetch(`${SERVER_URL}/api/auth/update/${user.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      // Update profile info
      const profileRoute =
        user.user.role === "ADMIN"
          ? "/api/admin/profile"
          : "/api/auth/update/:id";

      const profileBody =
        user.user.role === "ADMIN"
          ? {
              firstName: formData.firstName,
              lastName: formData.lastName,
              jobTitle: formData.jobTitle,
              phone: formData.phone,
            }
          : {
              firstName: formData.firstName,
              lastName: formData.lastName,
              phone: formData.phone,
            };

      const profileRes = await fetch(`${SERVER_URL}${profileRoute}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(profileBody),
      });

      const data = await profileRes.json();

      if (profileRes.ok) {
        toast.success("Profile updated successfully!");
        setMessage("Profile updated successfully!");
      } else {
        setMessage(data.error || "Failed to update profile.");
      }
    } catch (error) {
      setMessage("An error occurred while updating the profile.");
    }
  };

  return (
    <div className="edit-profile-container">
      <h2>Edit Profile</h2>
      {message && <p className="message">{message}</p>}
      <form onSubmit={handleSubmit} className="edit-profile-form">
        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />

        <label>New Password (optional)</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
        />

        <label>First Name</label>
        <input
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
        />

        <label>Last Name</label>
        <input
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
        />

        {user.user.role === "ADMIN" && (
          <>
            <label>Job Title</label>
            <input
              type="text"
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleChange}
            />
          </>
        )}

        <label>Phone</label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />

        <button type="submit">Save Changes</button>
      </form>
    </div>
  );
};

export default EditProfile;
